import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import possibilityImage from '../../assets/place3.jpeg';
import slider1 from '../../assets/place1.jpg';
import slider2 from '../../assets/place4.jpeg';
import './index.css';

const Index = () => (
  <div className="gpt3__blog section__padding" id="blog">
    <div className="gpt3__features-container__feature-title">
      <div />
      <h1>MOST POPULAR PLACE</h1>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-sm">
          <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
            <div>
              <img src={possibilityImage} />
            </div>
            <div>
              <img src={slider1} />
            </div>
            <div>
              <img src={slider2} />
            </div>
          </Carousel>
          <button type="submit" className="btn btn-success col-sm">Details place </button>
        </div>
        <div className="col-sm">
          <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
            <div>
              <img src={possibilityImage} />
            </div>
            <div>
              <img src={slider1} />
            </div>
            <div>
              <img src={slider2} />
            </div>
          </Carousel>
          <button type="submit" className="btn btn-success col-sm">Details place </button>

        </div>
        <div className="col-sm">
          <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
            <div>
              <img src={possibilityImage} />
            </div>
            <div>
              <img src={slider1} />
            </div>
            <div>
              <img src={slider2} />
            </div>
          </Carousel>
          <button type="submit" className="btn btn-success col-sm">Details place </button>

        </div>
      </div>
    </div>
  </div>
);

export default Index;
